import React, { useState } from "react";
import {Link} from "react-router-dom";
import db from "../../firebase";  
import { useCollectionData } from "react-firebase-hooks/firestore";

function SponsoredPosts () {
    const sponsoredArticleRef = db.collection("specialArticles");
    const query = sponsoredArticleRef.where("type", "==", "sponsored");
    const [sponsored, loading, error] = useCollectionData(query);
    const [titleNimg, setTitleNimg] = useState({
        title: "Welcome",
        featuredImg: "https://drive.google.com/uc?id=1HiqjlnJgwV2hOYxAhCj2Q3XF5_FiNV6v"
    });
    const handleHover = (event) => {
        setTitleNimg({
            title: event.target.childNodes[0].innerHTML,
            featuredImg: event.target.childNodes[0].id
        });
    }
    // When you hover over the link, the div hover function doesn't get triggered. So we need to define linkHover function too
    const handleLinkHover = (event) => {
        setTitleNimg({
            title: event.target.innerHTML,
            featuredImg: event.target.id
        });
    }

    return (
        <section className="container-fluid" style={{margin: "10vh 0 2vh"}}>
            {sponsored && <div className="row">
                {loading && <h1>Loading...</h1>}
                {error && <h1>{error}</h1>}
                {/* <!-- The background of this section is the Featured image of the selected Sponsored Post --> */}
                <div className="col-md-8" id="featuredParent" style={{backgroundImage: `url(${titleNimg.featuredImg})`}}>
                    {/* <!-- The background of this part is black with 50% opacity --> */}
                    <div className="container-fluid" id="featured">
                        <div className="row" id="heading">
                            <h1>Our full Logo</h1>
                        </div>
                        <div className="row" id="spotlight">
                            <Link to={`/posts/${titleNimg.title}`}><h1>{titleNimg.title}</h1></Link>
                        </div>                    
                    </div>
                </div>
                {/* <!-- The section on the right which contains 3 Sponsored Posts --> */}
                <div className="col-md-4 p-0 sponsoredPostContainer">
                    {sponsored && sponsored[0].posts.map((post, i) => (
                        <div onMouseEnter={handleHover} className="sponsored-posts" key={i}>
                            <Link to={`/posts/${post.title}`} id={post.featuredImg} onMouseEnter={handleLinkHover}>
                                {post.title}
                            </Link>
                        </div>
                    ))}
                </div>
            </div>}
        </section>
    ); 
}

export default SponsoredPosts;